export const enum OrderDisputeStatuses {
  Received = '/admin/enum/order_dispute_statuses/received',
  Won = '/admin/enum/order_dispute_statuses/won',
  Lost = '/admin/enum/order_dispute_statuses/lost',
  Rejected = '/admin/enum/order_dispute_statuses/rejected',
}
